import { reverseGeocode as reverseGeocodeRepo } from '../../../data/repositories/locationRepository.js';

export const reverseGeocode = (lat, lon) => reverseGeocodeRepo(lat, lon);
